import * as c from '../constants/AppConstants'

// MODAL
export const openModal = (name, props) => ({ type: c.MODAL_OPEN, name, props })
export const startCloseModal = name => ({ type: c.MODAL_START_CLOSE })
export const finishCloseModal = name => (dispatch, getState) => {
  const currentModal = getState().app.modal.name
  dispatch({ type: c.MODAL_FINISH_CLOSE, name: currentModal !== name ? currentModal : null })
}
export const updateModal = () => ({ type: c.MODAL_UPDATE })

// DETAIL PANEL
export const openDetailPanel = (name, props) => ({ type: c.DETAIL_PANEL_OPEN, name, props })
export const startCloseDetailPanel = name => ({ type: c.DETAIL_PANEL_START_CLOSE })
export const finishCloseDetailPanel = name => (dispatch, getState) => {
  const currentDetailPanel = getState().app.detailPanel.name
  dispatch({ type: c.DETAIL_PANEL_FINISH_CLOSE, name: currentDetailPanel !== name ? currentDetailPanel : null })
}

// BREAKPOINT
export const changeBreakpoint = (breakpointObj) => ({ type: c.CHANGE_BREAKPOINT, payload: breakpointObj })

// TABS
export const setActiveTab = tab => ({ type: c.SET_ACTIVE_TAB, payload: tab })
